export { default as Body } from './Body';
export { default as Footer } from './Footer';
export { default as Faq } from './Faq';
export { default as Feature } from './Feature';
export { default as Header } from './Header';
export { default as Hero } from './Hero';
export { default as MultiProduct } from './MultiProduct';
export { default as Section } from './Section';
export { default as SingleProduct } from './SingleProduct';
